// Router.jsx
import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Footer from '../components/Footer';
import About from '../pages/About';
import Home from '../pages/Home';
import Contact from '../pages/Contact';
import NavbarComp from '../components/layouts/Navigation/NavbarComp';
import Introduction from '../pages/Introduction';
import OrganizationHistory from '../pages/OrganizationHistory';
import SystemDevelop from '../pages/business/SystemDevelop';
import FMSMonitoring from '../pages/business/FMSMonitoring';
import InfrastructureSystem from '../pages/business/InfrastructureSystem';
import Maintenance from '../pages/business/Maintenance';
import HeadBanner from '../components/HeadBanner';
import NotFound from '../pages/NotFound';
import Download from '../pages/Download';
import CompanyHistory from '../pages/CompanyHistory';

import ManageApp from '../manage/ManageApp';

const Router = () => {
  const location = useLocation();
  const isNotFound = location.pathname === '/404';
  const isManage = location.pathname.startsWith('/manage');

  if (isManage) {
    return (
      <Routes>
        <Route path="/manage/*" element={<ManageApp />} />
      </Routes>
    );
  }

  return (
    <div className="app-container">
      {!isNotFound && <NavbarComp isVisible />}
      {!isNotFound && location.pathname !== '/' && <HeadBanner />}
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/OrganizationHistory" element={<OrganizationHistory />} />
          <Route path="/about/Companyhistory" element={<CompanyHistory />} />
          <Route path="/business/SystemDevelop" element={<SystemDevelop />} />
          <Route path="/business/FMSMonitoring" element={<FMSMonitoring />} />
          <Route path="/business/InfrastructureSystem" element={<InfrastructureSystem />} />
          <Route path="/business/Maintenance" element={<Maintenance />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/introduction" element={<Introduction />} />
          <Route path="/download" element={<Download />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </div>
      {!isNotFound && <Footer />}
    </div>
  );
};

export default Router;
